import { render, staticRenderFns } from "./SaldosSalidasFiltersForm.vue?vue&type=template&id=828b7136"
import script from "./SaldosSalidasFiltersForm.vue?vue&type=script&lang=ts"
export * from "./SaldosSalidasFiltersForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports